// @flow
import { createReducer } from "redux-act";
import _ from 'lodash';
import * as actions from "../../actions";
import LocalStorage from '../../../utils/storage/LocalStorage';


const initial_state = {
	counter: 0,
	notification_bar: {
		text: '',
		show: 0,
	}
};

export const notifications = createReducer({}, initial_state);

notifications.on(actions.fetchNotificationsDraftSuccess, (state, payload) => ({
	...state,
	counter: _.size(_.get(payload, 'all', []))
}));

notifications.on(actions.fetchNotificationBarSuccess, (state, payload) => ({
	...state,
	notification_bar: payload
}));

notifications.on(actions.hideNotificationBar, state => {
	LocalStorage.set(
		'hide_notification_bar',
		'true'
	);
	return(
		{
			...state,
			notification_bar: {
				...state.notification_bar,
				show: 0
			}
		}
	);
});


export default notifications;


// WEBPACK FOOTER //
// ./src/modules/reducers/notifications/index.js